import { useState } from 'react';
import { useAppContext } from '../context/AppContext';
import { fetchPodData } from '../apis/pod';
import { PodData } from '../dtos/pod';
import { useParams } from 'react-router-dom';
interface PodDataHook {
  podData: PodData | null;
  podId: string | null;
  podIP: string | null;
  isLoadingPod: boolean;
  podError: string | null;
  loadPodData: (ipAddress: string) => Promise<PodData | undefined>;
  clearPodData: () => void;
}

export const usePodData = (): PodDataHook => {
  const { podData, setPodData, setLoading, setError } = useAppContext();
  const [isLoadingPod, setIsLoadingPod] = useState(false);
  const [podError, setPodError] = useState<string | null>(null);
  const { prefix: podIP = null } = useParams();

  const loadPodData = async (ipAddress: string): Promise<PodData | undefined> => {
    if (!ipAddress) return;

    const fetchPromise = (async () => {
      try {
        setIsLoadingPod(true);
        setPodError(null);
        setLoading(true);

        const data = await fetchPodData(ipAddress);
        setPodData(data);
        return data;
      } catch (error: any) {
        const message = error.message || 'Failed to load pod data';
        setPodError(message);
        setError(message);
      } finally {
        setIsLoadingPod(false);
        setLoading(false);
      }
    })();

    return fetchPromise;
  };

  const clearPodData = () => {
    setPodData(null);
    setPodError(null);
  };

  return {
    podData,
    podId: podData?.id?.toString() || null,
    podIP,
    isLoadingPod,
    podError,
    loadPodData,
    clearPodData,
  };
};